import { Carousel_Item_default } from "./chunk-JNBXRD36.js";
import { Carousel_default } from "./chunk-5F6ADXP4.js";
import { Carousel_Button_default } from "./chunk-FTSMOXGY.js";

// src/components/Carousel/index.ts
var CarouselComponent = Carousel_default;
CarouselComponent.Item = Carousel_Item_default;
CarouselComponent.Item.displayName = "Carousel.Item";
CarouselComponent.Button = Carousel_Button_default;
CarouselComponent.Button.displayName = "Carousel.Button";
export { CarouselComponent };